/* eslint-disable */
import { useState } from "react";
import { T, useTheme } from "../../../tokens";
import { Row } from "../../../shared/WireframePrimitives";
import ResponsiveShell from "../../../shared/ResponsiveShell";
import { PRODUCT_FOOTER } from "../../../shared/layoutTokens";

const CUST_NAV_ITEMS = [
  ["🔍", "Discover"],
  ["📦", "Orders"],
  ["👤", "Profile"],
];

export function CustSidebar({
  dark,
  active = "Discover",
  showBizOrders = false,
  collapsed = false,
}) {
  const th = useTheme(dark);
  const sidebarWidth = collapsed ? 56 : 156;
  const items = [
    ...CUST_NAV_ITEMS.slice(0, 2),
    ...(showBizOrders ? [["📋", "Orders for this Biz"]] : []),
    CUST_NAV_ITEMS[2],
  ];

  return (
    <div
      style={{
        width: sidebarWidth,
        flexShrink: 0,
        alignSelf: "stretch",
        background: dark ? "#0d1117" : T.lSurface,
        borderRight: `1px solid ${th.border}`,
        display: "flex",
        flexDirection: "column",
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: collapsed ? "center" : "flex-start",
          gap: 6,
          padding: collapsed ? "10px 8px 8px" : "10px 12px 8px",
          borderBottom: `1px solid ${th.border}`,
        }}
      >
        <div
          style={{
            width: 20,
            height: 20,
            borderRadius: 5,
            background: T.brand,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: 10,
            fontWeight: 700,
            color: "#fff",
          }}
        >
          Z
        </div>
        {!collapsed && (
          <span style={{ fontSize: 11, fontWeight: 600, color: th.text, letterSpacing: "-0.01em" }}>MyHub</span>
        )}
      </div>
      <div style={{ padding: "6px 0", flex: 1 }}>
        {items.map(([icon, label]) => {
          const isActive = label === active;
          return (
            <div
              key={label}
              title={collapsed ? label : undefined}
              style={{
                display: "flex",
                alignItems: "center",
                gap: 7,
                padding: collapsed ? "7px 8px" : "7px 12px",
                fontSize: 11,
                justifyContent: collapsed ? "center" : "flex-start",
                background: isActive ? T.brandSoft : "none",
                color: isActive ? T.brand : th.textSec,
                fontWeight: isActive ? "500" : "400",
                transition: th.tr,
                cursor: "default",
                borderLeft: isActive ? `2px solid ${T.brand}` : "2px solid transparent",
                margin: "1px 0",
              }}
            >
              <span style={{ fontSize: 13, flexShrink: 0 }}>{icon}</span>
              {!collapsed && (
                <span style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{label}</span>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}

export function CustTopbar({
  dark,
  loggedIn = false,
  cartCount = 0,
  viewport = "desktop",
  onMenuToggle,
}) {
  const th = useTheme(dark);
  const mob = viewport === "mobile";

  return (
    <div
      style={{
        height: 40,
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "0 12px",
        borderBottom: `1px solid ${th.border}`,
        background: dark ? "rgba(10,13,18,0.97)" : "rgba(255,255,255,0.97)",
        flexShrink: 0,
      }}
    >
      <Row gap={8}>
        {mob && onMenuToggle && (
          <button
            type="button"
            onClick={onMenuToggle}
            style={{ background: "none", border: "none", cursor: "pointer", fontSize: 16, color: th.textSec, padding: 4 }}
          >
            ☰
          </button>
        )}
        <span style={{ fontSize: 10, color: th.textMuted, letterSpacing: "0.02em" }}>visitmyhub.online</span>
      </Row>
      <Row gap={6}>
        <div
          style={{
            width: 28,
            height: 15,
            borderRadius: 8,
            background: dark ? T.brand : "rgba(128,128,128,0.2)",
            display: "flex",
            alignItems: "center",
            padding: "0 2px",
            justifyContent: dark ? "flex-end" : "flex-start",
            cursor: "default",
            flexShrink: 0,
          }}
        >
          <div style={{ width: 11, height: 11, borderRadius: "50%", background: "#fff" }} />
        </div>
        <div style={{ position: "relative", cursor: "default", flexShrink: 0 }}>
          <div
            style={{
              width: 24,
              height: 24,
              borderRadius: 6,
              background: dark ? "rgba(255,255,255,0.08)" : "rgba(0,0,0,0.05)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke={dark ? "#f1f5f9" : "#334155"} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <circle cx="9" cy="21" r="1" />
              <circle cx="20" cy="21" r="1" />
              <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6" />
            </svg>
          </div>
          {cartCount > 0 && (
            <div
              style={{
                position: "absolute",
                top: -3,
                right: -3,
                width: 13,
                height: 13,
                borderRadius: "50%",
                background: T.red,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: 7,
                color: "#fff",
                fontWeight: 700,
              }}
            >
              {cartCount}
            </div>
          )}
        </div>
        {loggedIn ? (
          <Row gap={5}>
            <div
              style={{
                height: 24,
                padding: "0 7px",
                background: "rgba(128,128,128,0.08)",
                borderRadius: 5,
                display: "flex",
                alignItems: "center",
                gap: 3,
                fontSize: 9,
                color: th.textSec,
                cursor: "default",
                border: `1px solid ${th.border}`,
              }}
            >
              <svg width="9" height="9" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <circle cx="12" cy="8" r="4" />
                <path d="M4 20c0-4 3.6-7 8-7s8 3 8 7" />
              </svg>
              ss bb
            </div>
          </Row>
        ) : (
          <Row gap={4}>
            <div
              style={{
                height: 22,
                padding: "0 8px",
                background: T.brandSoft,
                borderRadius: 5,
                border: `1px solid ${T.brandBorder}`,
                fontSize: 9,
                fontWeight: 500,
                color: T.brand,
                display: "flex",
                alignItems: "center",
                cursor: "default",
              }}
            >
              Login
            </div>
            <div
              style={{
                height: 22,
                padding: "0 8px",
                background: T.brand,
                borderRadius: 5,
                fontSize: 9,
                fontWeight: 500,
                color: "#fff",
                display: "flex",
                alignItems: "center",
                cursor: "default",
              }}
            >
              Register
            </div>
          </Row>
        )}
      </Row>
    </div>
  );
}

export function CustFooter({ dark }) {
  const th = useTheme(dark);
  return (
    <div
      style={{
        height: 30,
        borderTop: `1px solid ${th.border}`,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: 9,
        color: th.textMuted,
        background: th.surface,
        flexShrink: 0,
        gap: 6,
      }}
    >
      {PRODUCT_FOOTER[0]}{' '}<span style={{color:T.brand}}>{PRODUCT_FOOTER[1]}</span>
    </div>
  );
}

/** CustShell layout — full-width topbar, ResponsiveShell body, pinned footer. */
export function CustAppShell({
  dark,
  viewport = "desktop",
  active = "Discover",
  showBizOrders = false,
  loggedIn = false,
  cartCount = 0,
  pageTitle,
  children,
}) {
  const title = pageTitle || active;
  const [navOpen, setNavOpen] = useState(false);
  const mob = viewport === "mobile";

  return (
    <div style={{ flex: 1, minHeight: 0, height: "100%", display: "flex", flexDirection: "column" }}>
      <ResponsiveShell
        dark={dark}
        viewport={viewport}
        pageTitle={title}
        navOpen={navOpen}
        onNavToggle={setNavOpen}
        fullHeader={
          <CustTopbar
            dark={dark}
            loggedIn={loggedIn}
            cartCount={cartCount}
            viewport={viewport}
            onMenuToggle={mob ? () => setNavOpen((open) => !open) : undefined}
          />
        }
        footer={<CustFooter dark={dark} />}
        sidebar={({ collapsed }) => (
          <CustSidebar dark={dark} active={active} showBizOrders={showBizOrders} collapsed={collapsed} />
        )}
      >
        <div style={{ flex: 1, minWidth: 0, minHeight: 0, display: "flex", flexDirection: "column" }}>{children}</div>
      </ResponsiveShell>
    </div>
  );
}
